import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconUser: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}
                >
                    <path
                        d="M10.6666 4.33329C10.6666 5.80605 9.47268 6.99996 7.99992 6.99996C6.52716 6.99996 5.33325 5.80605 5.33325 4.33329C5.33325 2.86053 6.52716 1.66663 7.99992 1.66663C9.47268 1.66663 10.6666 2.86053 10.6666 4.33329Z"
                        stroke="currentColor"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.00008 8.33337C5.02038 8.33337 2.92911 10.6766 2.66675 13.6667H13.3334C13.0711 10.6766 10.9798 8.33337 8.00008 8.33337Z"
                        stroke="currentColor"
                        strokeLinejoin="round"
                    />
                </svg>
            );
    }
};
